import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { Project, SiteWithBeacons } from "../../../api/models";
import { NavigatableText } from "../../../util/NavigatableText";
import { formatLocalizedDateTime } from "../../../util/formatting";

interface SitesDetailsProps {
  constructionProject: Project | undefined;
  handleSiteClicked: (
    siteId: string,
    projectName: string,
    projectId: string,
    orgId: string
  ) => void;
}

export const SitesDetails = ({
  constructionProject,
  handleSiteClicked,
}: SitesDetailsProps) => {
  const { t } = useTranslation();

  const handleSiteNameClick = (params: { [key: string]: string }) => {
    if (handleSiteClicked) {
      handleSiteClicked(
        params.id,
        params.projectName,
        params.projectId,
        params.organizationId
      );
    }
  };

  const columns = [
    {
      key: "name",
      title: t("construction-site:name"),
      width: "auto",
      render: (s: SiteWithBeacons) => (
        <NavigatableText
          text={s.name}
          params={{
            id: s.id,
            projectName: constructionProject?.name || "",
            projectId: constructionProject?.id || "",
            organizationId: constructionProject?.org.id || "",
          }}
          type="callback"
          callBack={handleSiteNameClick}
        />
      ),
    },
    {
      key: "createdAt",
      title: t("translations:created-date"),
      width: "auto",
      render: (s: SiteWithBeacons) =>
        formatLocalizedDateTime(s.createdAt),
    },
  ];
  return (
    <div>
      <div className="sub-title-container">
        {t("construction-site:sites-in-project")}
      </div>

      <Table
        columns={columns}
        scroll={{ y: `calc(100vh - 400px)` }}
        rowKey={(record) => record.id}
        dataSource={constructionProject?.sites}
        pagination={false}
        loading={false}
      />
    </div>
  );
};
